import React, { ReactNode } from 'react';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ResourceIcon from '~/assets/images/resource-icon.svg';

interface EmptyStateCardProps {
  title: string;
  description: ReactNode;
  icon?: ReactNode;
  buttonLabel?: string;
  buttonLink?: string;
  paddingX?: number;
  paddingY?: number;
  testId?: string;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  title,
  description,
  icon = undefined,
  buttonLabel = undefined,
  buttonLink = undefined,
  paddingX = 8,
  paddingY = 8,
  testId = undefined,
}) => {
  return (
    <Card sx={{ borderRadius: '6px' }} data-testid={testId}>
      <CardContent
        sx={{
          px: paddingX,
          pt: paddingY,
          '&:last-child': {
            pb: paddingY,
          },
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={10}>
          <Stack justifyContent="center" height={350}>
            {icon ?? (
              <img
                src={ResourceIcon}
                alt="Resource Icon"
                width={120}
                height={120}
              />
            )}
          </Stack>

          <Stack justifyContent="center" spacing={2}>
            <Typography
              alignSelf={{ xs: 'center', sm: 'flex-start' }}
              fontSize={22}
              fontWeight={600}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              pb={{ xs: paddingY === 0 ? 4 : 0, sm: 0 }}
            >
              {description}
            </Typography>
            {buttonLink && (
              <Button
                variant="contained"
                href={buttonLink}
                sx={{ alignSelf: { xs: 'stretch', sm: 'flex-start' } }}
                data-testid="empty-state-action-button"
              >
                {buttonLabel}
              </Button>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default EmptyStateCard;
